export default __webpack_public_path__ + "static/media/Bird4.cfd1e7aa.png";